import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-53dd446a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "installment-list" }
const _hoisted_2 = {
  key: 0,
  class: "pay-before-subtitle"
}
const _hoisted_3 = {
  key: 0,
  class: "overdue-label"
}
const _hoisted_4 = {
  key: 1,
  class: "pay-before-label"
}
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardItem = _resolveComponent("CardItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('InstallmentsList-Title')), 1),
    (_ctx.payBeforeDate)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          (_ctx.payBeforeDate.isOverdue)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.payBeforeDatePrefix), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t("pay-before")), 1)),
          _createTextVNode(" " + _toDisplayString(_ctx.payBeforeDate.datetime), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", {
      class: _normalizeClass({ 'margin-top-zero': _ctx.payBeforeDate })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installmentsAlwaysAvailable, (i, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createVNode(_component_CardItem, {
            title: i.label,
            subtitle: i.subtitle,
            "right-text": _ctx.computeAmountDisplay(i.amount),
            "right-text-bold": true,
            onClick: ($event: any) => (_ctx.handleInstallmentClick(i))
          }, null, 8, ["title", "subtitle", "right-text", "onClick"])
        ]))
      }), 128))
    ], 2),
    (!_ctx.hideMoreOptions)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "installment-list-toggle-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleConditionalInstallments && _ctx.toggleConditionalInstallments(...args)))
        }, _toDisplayString(_ctx.t("superpacman-more-options")), 1))
      : _createCommentVNode("", true),
    (_ctx.showConditionalInstallments && !_ctx.hideMoreOptions)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installmentsConditional, (i, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_CardItem, {
                title: i.label,
                "right-text": _ctx.computeAmountDisplay(i.amount),
                "right-text-bold": true,
                onClick: ($event: any) => (_ctx.handleInstallmentClick(i))
              }, null, 8, ["title", "right-text", "onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}